












import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company, FinanceInfo, CompanySummaryReport } from '@/utils/Interfaces'
import BaoCaoGeneric from '@/components/BaoCaoGeneric.vue'

declare interface FormattedReport extends CompanySummaryReport {
  company: Company['name'];
  finance_info: CompanySummaryReport['finance_info'];
  doanh_thu_cong_ich_ke_hoach: CompanySummaryReport['doanh_thu_cong_ich_ke_hoach'];
  doanh_thu_cong_ich_thuc_hien: CompanySummaryReport['doanh_thu_cong_ich_thuc_hien'];
  doanh_thu_cong_ich_kh_chia_th: CompanySummaryReport['doanh_thu_cong_ich_kh_chia_th'];
  doanh_thu_ngoai_cong_ich_ke_hoach: CompanySummaryReport['doanh_thu_ngoai_cong_ich_ke_hoach'];
  doanh_thu_ngoai_cong_ich_thuc_hien: CompanySummaryReport['doanh_thu_ngoai_cong_ich_thuc_hien'];
  doanh_thu_ngoai_cong_ich_kh_chia_th: CompanySummaryReport['doanh_thu_ngoai_cong_ich_kh_chia_th'];
  loi_nhuan_ke_hoach: CompanySummaryReport['loi_nhuan_ke_hoach'];
  loi_nhuan_thuc_hien: CompanySummaryReport['loi_nhuan_thuc_hien'];
  loi_nhuan_kh_chia_th: CompanySummaryReport['loi_nhuan_kh_chia_th'];
  tien_luong_nguoi_quan_ly_ke_hoach: CompanySummaryReport['tien_luong_nguoi_quan_ly_ke_hoach'];
  tien_luong_nguoi_quan_ly_thuc_hien: CompanySummaryReport['tien_luong_nguoi_quan_ly_thuc_hien'];
  tien_luong_nguoi_quan_ly_kh_chia_th: CompanySummaryReport['tien_luong_nguoi_quan_ly_kh_chia_th'];
  tien_luong_nguoi_lao_dong_ke_hoach: CompanySummaryReport['tien_luong_nguoi_lao_dong_ke_hoach'];
  tien_luong_nguoi_lao_dong_thuc_hien: CompanySummaryReport['tien_luong_nguoi_lao_dong_thuc_hien'];
  tien_luong_nguoi_lao_dong_kh_chia_th: CompanySummaryReport['tien_luong_nguoi_lao_dong_kh_chia_th'];
  ty_le_co_tuc_tong_cong_ty: CompanySummaryReport['ty_le_co_tuc_tong_cong_ty'];
  ty_le_co_tuc_tong_don_vi: CompanySummaryReport['ty_le_co_tuc_tong_don_vi'];
  co_tuc_ke_hoach_tong_cong_ty: CompanySummaryReport['co_tuc_ke_hoach_tong_cong_ty'];
  co_tuc_thuc_hien_tong_cong_ty: CompanySummaryReport['co_tuc_thuc_hien_tong_cong_ty'];
  co_tuc_kh_chia_th_tong_cong_ty: CompanySummaryReport['co_tuc_kh_chia_th_tong_cong_ty'];
  co_tuc_ke_hoach_don_vi: CompanySummaryReport['co_tuc_ke_hoach_don_vi'];
  co_tuc_thuc_hien_don_vi: CompanySummaryReport['co_tuc_thuc_hien_don_vi'];
  co_tuc_kh_chia_th_don_vi: CompanySummaryReport['co_tuc_kh_chia_th_don_vi'];
}


@Component({
  components: {
    BaoCaoGeneric,
  }
})
export default class BaoCaoBangTongHop extends Vue {
  @Prop(Array) readonly reports!: Array<CompanySummaryReport>

  reportType = 'BaoCaoBangTongHop'

  headerMapper: { [index: string]: string } = {
    company: 'Công ty',
    doanh_thu_cong_ich_ke_hoach: 'Doanh thu công ích kế hoạch',
    doanh_thu_cong_ich_thuc_hien: 'Doanh thu công ích thực hiện',
    doanh_thu_cong_ich_kh_chia_th: 'Doanh thu công ích KH/TH',
    doanh_thu_ngoai_cong_ich_ke_hoach: 'Doanh thu ngoài công ích kế hoạch',
    doanh_thu_ngoai_cong_ich_thuc_hien: 'Doanh thu ngoài công ích thực hiện',
    doanh_thu_ngoai_cong_ich_kh_chia_th: 'Doanh thu ngoài công ích KH/TH',
    loi_nhuan_ke_hoach: 'Lợi nhuận kế hoạch',
    loi_nhuan_thuc_hien: 'Lợi nhuận thực hiện',
    loi_nhuan_kh_chia_th: 'Lợi nhuận KH/TH',
    tien_luong_nguoi_quan_ly_ke_hoach: 'Tiền lương người quản lý kế hoạch',
    tien_luong_nguoi_quan_ly_thuc_hien: 'Tiền lương người quản lý thực hiện',
    tien_luong_nguoi_quan_ly_kh_chia_th: 'Tiền lương người quản lý KH/TH',
    tien_luong_nguoi_lao_dong_ke_hoach: 'Tiền lương người lao động kế hoạch',
    tien_luong_nguoi_lao_dong_thuc_hien: 'Tiền lương người lao động thực hiện',
    tien_luong_nguoi_lao_dong_kh_chia_th: 'Tiền lương người lao động KH/TH',
    ty_le_co_tuc_tong_cong_ty: 'Tỷ lệ cổ tức TCT',
    ty_le_co_tuc_don_vi: 'Tỷ lệ cổ tức ĐV',
    co_tuc_ke_hoach_tong_cong_ty: 'Cổ tức kế hoạch TCT',
    co_tuc_thuc_hien_tong_cong_ty: 'Cổ tức thực hiện TCT',
    co_tuc_kh_chia_th_tong_cong_ty: 'Cổ tức KH/TH TCT',
    co_tuc_ke_hoach_don_vi: 'Cổ tức kế hoạch ĐV',
    co_tuc_thuc_hien_don_vi: 'Cổ tức thực hiện ĐV',
    co_tuc_kh_chia_th_don_vi: 'Cổ tức KH/TH ĐV',
  }

  formatMapper: { [index: string]: string | null } = {
    company: 'link',
    doanh_thu_cong_ich_ke_hoach: 'money',
    doanh_thu_cong_ich_thuc_hien: 'money',
    doanh_thu_cong_ich_kh_chia_th: 'percentage',
    doanh_thu_ngoai_cong_ich_ke_hoach: 'money',
    doanh_thu_ngoai_cong_ich_thuc_hien: 'money',
    doanh_thu_ngoai_cong_ich_kh_chia_th: 'percentage',
    loi_nhuan_ke_hoach: 'money',
    loi_nhuan_thuc_hien: 'money',
    loi_nhuan_kh_chia_th: 'percentage',
    tien_luong_nguoi_quan_ly_ke_hoach: 'money',
    tien_luong_nguoi_quan_ly_thuc_hien: 'money',
    tien_luong_nguoi_quan_ly_kh_chia_th: 'percentage',
    tien_luong_nguoi_lao_dong_ke_hoach: 'money',
    tien_luong_nguoi_lao_dong_thuc_hien: 'money',
    tien_luong_nguoi_lao_dong_kh_chia_th: 'percentage',
    ty_le_co_tuc_tong_cong_ty: 'percentage',
    ty_le_co_tuc_don_vi: 'percentage',
    co_tuc_ke_hoach_tong_cong_ty: 'money',
    co_tuc_thuc_hien_tong_cong_ty: 'money',
    co_tuc_kh_chia_th_tong_cong_ty: 'percentage',
    co_tuc_ke_hoach_don_vi: 'money',
    co_tuc_thuc_hien_don_vi: 'money',
    co_tuc_kh_chia_th_don_vi: 'percentage',
  }

  choicesMapper: { [index: string]: unknown } = {}

  get formattedReports () {
    const formattedReports: Array<FormattedReport> = []

    this.reports.forEach(report => {
      // @ts-expect-error
      const formattedReport: FormattedReport = {}

      // Get company name
      const financeInfo = report.finance_info as FinanceInfo
      const company = financeInfo.company as Company
      const companyName = company.name
      formattedReport.company = companyName

      // Get remaining info
      Object.assign(formattedReport, report)
      // Remove not needed info
      delete formattedReport.finance_info
      delete formattedReport.created_at
      delete formattedReport.updated_at

      formattedReports.push(formattedReport)
    })

    return formattedReports
  }
}
